export const setRequestedReservationStatus = ({commit}, state) => {
  commit('requestedReservationStatus', state)
}



// WEBPACK FOOTER //
// ./src/store/actions.js